import React from 'react';
import type { SelectCountryListProps } from './types';
import Header from '@pixum/header';
import Text, { TEXT_VARIANT } from '@pixum/text';
import Label from '@pixum/label';
import { getIconByName } from '../icons';
import { filterVisiblePages } from 'utils';
import { SelectCountryListHeader } from './SelectCountryListHeader';
import './styles.css';

export function SelectCountryList({ pages, constants, productReviews }: SelectCountryListProps) {
  const headline = constants?.['i18n_welcome_to_pixum'] as string;
  const title = constants?.['i18n_selectcountry_choose_your_country'] as string;
  const subTitle = constants?.['i18n_selectcountry_choose_your_country_subtitle'] as string;

  const visiblePages = filterVisiblePages(pages);

  return (
    <section id="select-country-list" className="main-section center--content select-country-list">
      <SelectCountryListHeader headline={headline} productReviews={productReviews} />
      {title && <Header headlineText={title} headlineVariant={TEXT_VARIANT.TITLE_2} textAlignment="center" />}
      {subTitle && (
        <Text variant={TEXT_VARIANT.BODY} center>
          {subTitle}
        </Text>
      )}
      <ul className="select-country-list__columns">
        {visiblePages.map(page => {
          const code = page.locale?.split('-')[1]?.toUpperCase();
          const flag = code ? getIconByName(`flag-${code}`) : undefined;

          return (
            <li key={page.siteBranch} className="select-country-list__item">
              <Label href={page.homepage} icon={flag} showIcon text={page.name} title={page.name} />
            </li>
          );
        })}
      </ul>
    </section>
  );
}
